// eslint-disable-next-line
export const noOp = (arg?: any) => {}

export const makeNoOp = () => () => {}

export const noOpNull = () => null
export const noOpPromise = () => Promise.resolve()
